import { TranslationKeys } from '../../sections/TextDesign/constants';
import ShadowsPanel from './ShadowsPanel';

export default {
  component: ShadowsPanel,
  panelTitle: TranslationKeys.shadows.shadowSettings,
};
